import { HttpHeaders } from "@angular/common/http";
import { environment } from "src/environments/environment";

export function generateCorrelationId(): string {
    const email = localStorage.getItem('ACTIVA_REDACTEUR_EMAIL') || 'unknown_email';
    const userId = localStorage.getItem('ACTIVA_REDACTEUR_BANCASSURANCEUSERID') || 'unknown_user';
    const timestamp = new Date().getTime();

    console.log('🔍 Debug generateCorrelationId:');
    console.log('  - Email from localStorage:', email);
    console.log('  - UserId from localStorage:', userId);
    console.log('  - Timestamp:', timestamp);

    const correlationId = `${email}_${userId}_${timestamp}`;
    console.log('  - Generated Correlation ID:', correlationId);

    return correlationId;
}

export function getHeaders(): HttpHeaders {
    const correlationId = generateCorrelationId();
    const subscriptionKey = environment.Ocp_Apim_Subscription_Key;


    const headers = new HttpHeaders({
        'Content-Type': 'application/json',
        'X-Correlation-ID': correlationId,
        'Ocp-Apim-Subscription-Key': subscriptionKey
    });

    return headers;
}

export function getHeaderEdition(): HttpHeaders {
    const correlationId = generateCorrelationId();
    const subscriptionKey = environment.Ocp_Apim_Subscription_Key;

    const headers = new HttpHeaders({
       
        'X-Correlation-ID': correlationId,
        'Ocp-Apim-Subscription-Key': subscriptionKey
    });

    return headers;
}